import { render, staticRenderFns } from "./packageDetail.vue?vue&type=template&id=074f9670&scoped=true&"
import script from "./packageDetail.vue?vue&type=script&lang=js&"
export * from "./packageDetail.vue?vue&type=script&lang=js&"
import style0 from "./packageDetail.vue?vue&type=style&index=0&id=074f9670&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074f9670",
  null
  
)

export default component.exports